import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class UserShipDetails extends Mixins(CommonView) {
    kurukuru: boolean = false;
    pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"}, {name: "マイページ", path: "/mypage"}, {name: "配送履歴", path: "/mypage/userShip"}, {name: "配送履歴詳細", path: null}];
    public error: string = "";

    public userShip: BASEAPI.UserProductShip | null = null;
    public userPrizeList: BASEAPI.UserPrize[] = [];
    public visible: boolean = false;
    public i: number | null = null;

    public async created() {
        if (await this.isLoginRedirect(true)) return;
        
        await this.init();

    }

    @Watch('$route')
    public async init() {
        if (await this.isLoginRedirect(true)) return;

        this.kurukuru = true;

        this.getGender();

        let directoryName = this.$route.params.directoryName;
        if(!directoryName) {
            this.$router.push(this.men ? "/men" : "/");
            return;
        }

        let res = await BASEAPI.UserProductShipController.getUserProductShipUsingGET(directoryName).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        this.userShip = res.data;

        let resPrize = await BASEAPI.OrderHistoryPrizeController.getUserPrizeUsingGET(directoryName).catch(AxiosErrorHandler);
        if (isAxiosError(resPrize)) {
            this.error = "" + resPrize.data;
            return;
        }
        this.userPrizeList = resPrize.data;
        this.mode = "CONFIRM";
        this.kurukuru = false;
    }

    public mode:"CONFIRM" | "EDIT" = "CONFIRM";
    public edit(){
        this.mode = "EDIT";
    }

    public save(){
        this.mode = "CONFIRM";
    }

    public men: boolean = false;
    public getGender() {
        this.men = false;
        let fullPath = this.$route.fullPath;
        if(fullPath.substring(0, 4) == "/men"){
            this.men = true;
        }
    }
}
